module.exports = __webpack_public_path__ + "img/store-bigcommerce.fb9a3f50.svg";